import {createBrowserHistory, History} from 'history';

import appConfig from '../config/appConfig';

let history: History;

const getHistory = (): History => {
    if (!history) {
        history = createBrowserHistory({
            basename: appConfig.getBaseNameFormatted(),
        });
    }

    return history;
};

export default {
    getHistory,
};
